module.exports = __webpack_public_path__ + "static/media/icyGirl.c3925831.jpg";